import { removeHtmlTags, resetPercentatgeVist, getDataUTC } from '@portal-internet/core';
import { useViewport } from '../../../../hooks/3catinfo/useViewport';
import clsx from 'clsx';
import AfegeixALaLlista from 'components/3catinfo/AfegeixALaLlista';
import Boto from 'components/3catinfo/Boto';
import Compartir from 'components/3catinfo/Compartir';
import Etiquetes from 'components/3catinfo/Etiquetes';
import Etiqueta from 'components/3catinfo/Etiqueta';
import Imatge, { hasImatge, getPeu } from 'components/3catinfo/Imatge';
import Player from 'components/3catinfo/Player';
import Players from 'components/3catinfo/Players';
import ItemAutor from 'components/3catinfo/ItemAutor';
import __isEmpty from 'lodash/isEmpty';
import { getTimeNoti } from 'utils/3catinfo/dateHelper';
import { getDirecte } from 'utils/canals';
import Tag from '../Tag';
import TempsLectura from '../TempsLectura';
import styles from './capcalera.module.scss';
import { useState, useEffect, useRef } from 'react';
import Enllac from 'components/3catinfo/Enllac';

const BarraAccions = (props) => {
    const { titol, tts, tagPrincipal, tags, tipologia, id, programaTV, programaRadio, botoGoogle = {} } = props;
    const [mostrarPlayerTTS, setMostrarPlayerTTS] = useState(false);
    const { link: urlBotoGoogle, text: textBotoGoogle, imatge: imatgeBotoGoogle } = botoGoogle;
    const [visibleTooltipBotoTTS, setVisibleTooltipBotoTTS] = useState(false);
    const [msgTooltipBotoTTS, setMsgTooltipBotoTTS] = useState(true);
    const [isHovered, setIsHovered] = useState(false);
    const timeoutRef = useRef(null);

    const { isMobile } = useViewport();

    useEffect(() => {
        if (tts && !mostrarPlayerTTS) resetPercentatgeVist(id, 'WCR_AUDIO_MM');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mostrarPlayerTTS]);

    const stylesBotoTTS = clsx({
        [styles.tts_btn]: true,
        [styles.tts_active]: mostrarPlayerTTS,
        [styles.hovered]: isHovered
    });
    const stylesTooltipTTS = clsx({
        [styles.tooltipBox]: true,
        [styles.esquerra]: !isMobile,
        [styles.forMobile]: isMobile
    });

    const handleMouseEnter = (noHover = false) => {
        setVisibleTooltipBotoTTS(true);
        if (noHover) setIsHovered(true);
        clearTimeout(timeoutRef.current);
        if (mostrarPlayerTTS) {
            setMsgTooltipBotoTTS("Tanca el reproductor d'àudio");
        } else {
            setMsgTooltipBotoTTS('Escolta la notícia');
        }
    };

    const handleMouseLeave = (noHover = false) => {
        setVisibleTooltipBotoTTS(false);
        if (noHover) setIsHovered(false);
        timeoutRef.current = setTimeout(() => {
            setMsgTooltipBotoTTS('');
        }, 300);
    };

    const handleClick = () => {
        clearTimeout(timeoutRef.current);
        setMostrarPlayerTTS(!mostrarPlayerTTS);
        setMsgTooltipBotoTTS('');
        if (isMobile) {
            setIsHovered(false);
            setVisibleTooltipBotoTTS(false);
        }
        setTimeout(() => {
            if (!mostrarPlayerTTS) {
                setMsgTooltipBotoTTS("Tanca el reproductor d'àudio");
            } else {
                setMsgTooltipBotoTTS('Escolta la notícia');
            }
        }, 750);
    };

    const audiencies = {
        programa: programaTV?.desc || programaRadio?.desc,
        pagename: titol
    };
    return (
        <>
            <div className={styles.accions} data-testid='item-noti-accions'>
                <div className={styles.accionsTop}>
                    <div className={styles.tematiques}>
                        {tagPrincipal && (
                            <div className={styles.containerCategoryTags}>
                                <Tag tag={tagPrincipal} tipologia={'DTY_CATEGORY'} estil='headerNoticia' tooltipInici={true} />
                            </div>
                        )}
                    </div>
                    <div className={styles.accionsNoti}>
                        {tts && (
                            <div className={styles.tts}>
                                <Boto
                                    onClick={handleClick}
                                    icona='auriculars_ple'
                                    className={stylesBotoTTS}
                                    tag='button'
                                    estil='transparent small'
                                    ariaLabelBtn='Lector notícia'
                                    onMouseEnter={() => handleMouseEnter(true)}
                                    onMouseLeave={() => handleMouseLeave(true)}
                                    onFocus={() => handleMouseEnter(false)}
                                    onBlur={() => handleMouseLeave(false)}
                                    isIconaDreta={false}
                                    isIconaBlanc={false}
                                    iconaInline={true}
                                    mida={24}
                                />
                                {visibleTooltipBotoTTS && msgTooltipBotoTTS && (
                                    <div className={stylesTooltipTTS}>{msgTooltipBotoTTS}</div>
                                )}
                            </div>
                        )}
                        <AfegeixALaLlista
                            tipologia={tipologia}
                            id={id}
                            estil='positiu'
                            isBlanc={false}
                            textTooltipInactiu='Guarda&#39;t la not&#237;cia'
                            audiencies={audiencies}
                        />
                        <Compartir
                            titolCompartirMobil={titol}
                            obreEsquerra={true}
                            titol={titol}
                            textTooltip='Comparteix la not&#237;cia'
                        />
                    </div>
                    {!__isEmpty(botoGoogle) && (
                        <>
                            <Enllac className={styles.botoGoogle} href={urlBotoGoogle} novaFinestra={true}>
                                <div className={styles.textGoogle}>{textBotoGoogle}</div>
                                <div>
                                    <div className={styles.iconaGoogleWrapper}>
                                        <Imatge
                                            src={imatgeBotoGoogle}
                                            layout='fill'
                                            objectFit='contain'
                                            className={styles.iconaGoogle}
                                            alt='Google'
                                        />
                                    </div>
                                </div>
                            </Enllac>
                        </>
                    )}
                </div>
                {mostrarPlayerTTS && (
                    <div className={styles.tts_player}>
                        <Players
                            tipus='tts'
                            {...props}
                            playerVideoTagId={`audio-tts-${id}`}
                            setMostrarPlayerTTS={setMostrarPlayerTTS}
                            mostrarPlayerTTS={mostrarPlayerTTS}
                        />
                    </div>
                )}
            </div>
        </>
    );
};
const DatesNoticia = (props) => {
    const { data_publicacio, data_modificacio } = props;
    const dataPub = getTimeNoti(data_publicacio, false);
    const dataMod = getTimeNoti(data_modificacio);

    return (
        <div className={styles.data_pub}>
            <time className={styles.data_pub} dateTime={getDataUTC(data_publicacio)} itemProp='datePublished'>
                <span>{dataPub}</span>
            </time>
            {data_modificacio && dataPub !== dataMod && (
                <time dateTime={getDataUTC(data_modificacio)} itemProp='dateModified'>
                    <span className={styles.data_mod}>Actualitzat {dataMod}</span>
                </time>
            )}
        </div>
    );
};

const BarraInfo = (props) => {
    const { autors, redactor, temps_lectura, lloc } = props;
    const stylesDates = clsx({
        [styles.datesTemps]: true,
        [styles.borderTop]: !__isEmpty(autors) || !__isEmpty(redactor)
    });

    return (
        <div className={styles.infoBackground}>
            <div className={styles.info} data-testid='item-noti-info'>
                {(autors || redactor) && (
                    <div className={styles.autor}>
                        <ItemAutor
                            className={'capcalera_noticia'}
                            redactor={redactor}
                            autors={autors}
                            lloc={lloc}
                            mostrarTwitter={false}
                        />
                    </div>
                )}
                <div className={stylesDates}>
                    <DatesNoticia {...props} />
                    {temps_lectura && <TempsLectura className={styles.tempsLectura} text={temps_lectura} />}
                </div>
            </div>
        </div>
    );
};

const MediaCapcalera = (props) => {
    const { mediadestacats, mediadestacatsVideo, videos, hasImatgeGran, imatges, canalDirecte, isDirecte } = props;
    const [hideInfo, setHideInfo] = useState(false);
    const stylesEtiquetaDirecteWrapper = clsx({
        [styles.etiquetaDirecteWrapper]: true,
        [styles.hide]: hideInfo
    });

    const ocultaInfo = (estat) => {
        setHideInfo(estat);
    };
    if (isDirecte && canalDirecte?.tipus === 'video') {
        return (
            <figure className={styles.mainImgWrapper}>
                <div
                    className={styles.bigImgWrapper + ' ' + styles.bigVideoWrapper}
                    data-testid='item-noti-capcalera-video-directe'
                >
                    <Player
                        id={canalDirecte.canal}
                        imatges={imatges}
                        directe={true}
                        estils='noticia'
                        playerVideoTagId={`media-principal-video-${canalDirecte.canal}`}
                        ocultaInfo={ocultaInfo}
                    />
                </div>
                <div className={stylesEtiquetaDirecteWrapper}>
                    <Etiqueta
                        className={styles.labelEtiqueta}
                        text='En directe'
                        icona='directes'
                        isBlanc={true}
                        tipus='highlight'
                    />
                </div>
            </figure>
        );
    } else if (mediadestacats === 'VIDEO' && !__isEmpty(videos)) {
        return (
            <figure className={styles.mainImgWrapper}>
                <div className={styles.bigImgWrapper + ' ' + styles.bigVideoWrapper} data-testid='item-noti-capcalera-video'>
                    <Player id={videos[0].id} estils='noticia' playerVideoTagId={`media-principal-video-${videos[0].id}`} />
                </div>
            </figure>
        );
    } else if (mediadestacats === 'MP4' && mediadestacatsVideo?.[0]?.document) {
        const video = `https://statics.3cat.cat/multimedia/${mediadestacatsVideo?.[0]?.document}`;
        return (
            <figure className={styles.mainImgWrapper}>
                <div className={styles.bigImgWrapper + ' ' + styles.bigVideoWrapper} data-testid='item-noti-capcalera-video'>
                    <Players tipus='videoAnimat' urlMp4={video} estil='noticia' estilFormatVideo='format169' />
                </div>
            </figure>
        );
    } else if ((mediadestacats != 'VIDEO' || __isEmpty(videos)) && hasImatgeGran) {
        const peu = getPeu(imatges, 'web_destacat', true);
        return (
            <figure className={styles.mainImgWrapper}>
                <div className={styles.bigImgWrapper}>
                    <Imatge
                        imatges={imatges}
                        tipus='web_destacat'
                        layout='fill'
                        objectFit='cover'
                        mostrarRecurs={false}
                        priority={true}
                    />
                </div>
                {peu && <figcaption>{peu}</figcaption>}
            </figure>
        );
    } else {
        return <></>;
    }
};

const Capcalera = (props) => {
    const {
        titol,
        agrupacions,
        tags,
        imatges,
        programaTV,
        programaRadio,
        mediadestacats,
        mediadestacatsVideo,
        canalsDirectesEmbedats,
        videos
    } = props;
    const programa = programaTV || programaRadio;
    const [isHovered, setIsHovered] = useState(false);
    const entradeta = removeHtmlTags(props.entradeta);
    const _hasImatgeGran = mediadestacats !== 'CAP' ? hasImatge(imatges, 'web_destacat', null, null) : false;
    const isDirecte = !__isEmpty(canalsDirectesEmbedats);
    const canalDirecte = getDirecte(canalsDirectesEmbedats);
    const stylesInfoWrapper = clsx({
        [styles.infoWrapper]: true,
        [styles.senseMediaDestacat]: mediadestacats === 'CAP'
    });

    return (
        <>
            <div className={styles.itemnoticia} data-testid='item-noti-capcalera'>
                <MediaCapcalera
                    mediadestacats={mediadestacats}
                    mediadestacatsVideo={mediadestacatsVideo}
                    videos={videos}
                    hasImatgeGran={_hasImatgeGran}
                    imatges={imatges}
                    canalDirecte={canalDirecte}
                    isDirecte={isDirecte}
                />
                <div className={stylesInfoWrapper}>
                    {isDirecte && canalDirecte?.tipus === 'audio' && (
                        <Etiqueta
                            className={styles.labelEtiqueta}
                            text='En directe'
                            icona='directes'
                            isBlanc={true}
                            tipus='highlight'
                        />
                    )}
                    {!isDirecte && <Etiquetes agrupacions={agrupacions} tags={tags} />}
                    {programa && (
                        <div
                            className={styles.link3Cat}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <Boto
                                route={{ slug: programa.nom_bonic, type: 'web_3cat_programa' }}
                                estil='link3CatMagenta'
                                text={`${programa.desc} a 3Cat`}
                                icona='ic_linkexterior'
                                isIconaBlanc={isHovered}
                                novaFinestra={true}
                            />
                        </div>
                    )}
                    {titol && (
                        <h1 className={styles.titol} data-testid='item-noti-capcalera-titol'>
                            <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                        </h1>
                    )}
                    {entradeta && (
                        <div
                            className={styles.entradeta}
                            data-testid='item-noti-capcalera-entradeta'
                            dangerouslySetInnerHTML={{ __html: entradeta }}
                        ></div>
                    )}
                    <BarraInfo {...props} />
                </div>
                <BarraAccions key={props.id} {...props} />
            </div>
        </>
    );
};

export default Capcalera;
